<template>
    <component :is="component" dark>
        <slot />
    </component>
</template>

<style>
@font-face {
    font-family: 'regularFont';
    src: url('./assets/fonts/neris-light.otf') format('opentype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldFont';
    src: url('./assets/fonts/neris-black.otf') format('opentype');
    font-weight: bold;
}

@font-face {
    font-family: 'regularMontserratFont';
    src: url('./assets/fonts/montserrat-light.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldMontserratFont';
    src: url('./assets/fonts/montserrat-medium.ttf') format('truetype');
    font-weight: bold;
}

@font-face {
    font-family: 'regularRobotoFont';
    src: url('./assets/fonts/roboto-regular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldRobotoFont';
    src: url('./assets/fonts/roboto-bold.ttf') format('truetype');
    font-weight: bold;
}

body {
    background-position: center;
    background-size: cover;
}

.application {
    font-family: regularFont;
    background: transparent !important;
    font-size: 14px;
}

.swal2-container {
    font-family: regularFont;
}

.swal2-hide-cancel-button .swal2-cancel {
    display: none !important;
}

.text-bold {
    font-family: boldFont;
}

.text-regular {
    font-family: regularFont;
}

.container {
    padding: 20px !important;
    height: 100%;
}

button {
    font-family: boldFont;
    text-transform: initial !important;
}

button:not(.radius-inline) {
    border-radius: 25px !important;
}

a {
    text-decoration: underline;
}

.cursor-hover {
    cursor: pointer;
}

.cursor-hover:hover {
    opacity: 0.8;
}

.app-container {
    padding-left: 10px;
    padding-right: 10px;
    max-width: 800px;
    margin: 0 auto;
}

.app-title {
    font-family: boldFont;
    font-size: 18px;
    text-align: center;
    padding: 0 15px 10px;
    color: #fff;
}

.app-image {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
}

.app-image img {
    max-width: 40%;
    border-radius: 10px;
}

.app-text {
    font-size: 14px;
    color: #fff;
    white-space: break-spaces;
    padding: 0 15px 10px;
}

.app-error-info {
    font-size: 14px;
    color: #888;
    text-align: center;
    padding: 20px;
}

.app-error-info>div {
    margin-top: 5px;
}

.app-cards {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
}

.app-cards>div {
    flex: 50%;
    padding: 10px;
}

.app-cards .v-card__title {
    font-family: boldFont;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
}

.app-cards-float-icon {
    padding-left: 10px;
}

.app-notes {
    margin: 10px 0;
    background-color: #2b2b2b;
    border-radius: 6px;
    padding: 10px;
    text-align: center;
    color: #fff;
    font-size: 15px;
}

.app-videos>div {
    padding-top: 10px;
}

.app-videos {
    padding-top: 10px;
}

.app-videos video {
    width: 100%;
}

.select-filter .v-select {
    margin-top: 10px;
    margin-bottom: 5px;
}

.select-filter .v-select .v-input__slot {
    border: 1px solid #fff !important;
    background-color: #343434 !important;
    min-height: 40px;
    max-height: 40px;
}

.select-filter .v-select .v-select__selection--comma {
    margin: 0 !important;
}

.select-filter .v-select .v-input__icon .v-icon {
    color: #fff !important;
}

.select-filter .v-select .v-input__append-inner {
    margin-top: 8px !important;
}

.select-filter .v-select .v-select__selections {
    padding-top: 0 !important;
    color: #fff !important;
}

.v-select .v-input__icon svg {
    height: 16px;
}

.flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.app-footer {
    padding-top: 10px;
    padding-bottom: 20px;
}

/* Dark */
.v-sheet {
    background-color: #424242 !important;
    border-color: #424242 !important;
    color: #fff !important;
}

/* Montserrat */
.app-container-font-montserrat .application,
.app-container-font-montserrat .swal2-container {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .app-title,
.app-container-font-montserrat .app-cards .v-card__title {
    font-family: boldMontserratFont;
}

/* Roboto */
.app-container-font-roboto .application,
.app-container-font-roboto .swal2-container {
    font-family: regularRobotoFont;
}

.app-container-font-montserrat .app-title,
.app-container-font-montserrat .app-cards .v-card__title {
    font-family: boldRobotoFont;
}
</style>

<script>
import VuebaseLayout from './layouts/VuebaseLayout'
import Utils from './services/Utils'

export default {
    name: 'App',
    components: {
        VuebaseLayout
    },
    computed: {
        component() {
            return VuebaseLayout
        }
    },
    beforeMount: function () {
        const self = this
        localStorage.removeItem('enums')
        localStorage.removeItem('strings')
        Utils.initialize()
        window.addEventListener('message', function (event) {
            try {
                if (event && event.data) {
                    const data = JSON.parse(event.data)
                    if (data && data.event === 'start') {
                        document.documentElement.scrollTop = 0
                        self.resetRoute()
                        self.processData(data.data)
                    }
                    if (data && data.event === 'back') {
                        self.$root.$emit('app-back')
                    }
                    if (data && data.event === 'alerts-new-contents' && data.data) {
                        window.appCache = window.appCache ? window.appCache : {}
                        window.appCache.alertsNewContents = JSON.parse(data.data)
                    }
                }
            } catch (error) { }
        })
        document.addEventListener('message', function (event) {
            try {
                if (event && event.data) {
                    const data = JSON.parse(event.data)
                    if (data && data.event === 'start') {
                        self.resetRoute()
                        self.processData(data.data)
                    }
                    if (data && data.event === 'back') {
                        self.$root.$emit('app-back')
                    }
                }
            } catch (error) { }
        })
    },
    methods: {
        resetRoute: function () {
            try {
                const queryParams = { ...this.$route.query }
                if (queryParams) {
                    delete queryParams.type_label
                    delete queryParams.type_value
                    delete queryParams.sub_type_label
                    delete queryParams.sub_type_value
                }
                this.$router.push({
                    path: '/',
                    query: queryParams
                })
            } catch (error) { }
        },
        processData: function (data) {
            try {
                window.appCache = window.appCache ? window.appCache : {}
                if (data && data.alertsNewContents) {
                    window.appCache.alertsNewContents = data.alertsNewContents
                } else {
                    delete window.appCache.alertsNewContents
                }
                this.$root.$emit('app-refresh')
            } catch (error) { }
        },
    },
}
</script>
